import { Box, Chip, useTheme } from '@mui/material';
import { useCallback, useState } from 'react';
import TooltipComponent from '../../../components/TooltipComponent/TooltipComponent';
import { Typography } from '../../../components/Typography/Typography';
import { Deal } from '../../../types';

type Props = {
  deals: Partial<Deal>[] | undefined;
};

const maxDealsToShow = 4;
function DealCell({ deals }: Props) {
  const { colors } = useTheme();
  const [restDealsTooltipOpen, setRestDealsTooltipOpen] = useState(false);

  const handleRestDealsTooltipOpen = useCallback(() => {
    setRestDealsTooltipOpen(true);
  }, []);

  const handleRestDealsTooltipClose = useCallback(() => {
    setRestDealsTooltipOpen(false);
  }, []);

  const slicedDeals = deals?.slice(0, maxDealsToShow) || [];

  const restDeals = deals?.slice(maxDealsToShow, deals.length);

  const restDealsNumber = restDeals?.length;

  return (
    <Box display={'flex'} gap={1}>
      {slicedDeals.map((deal) => {
        return (
          <Chip
            key={deal.id}
            style={{
              backgroundColor: colors.surfaceStatus.noAction,
              minWidth: '66px',
              height: '28px',
            }}
            label={
              <Typography variant='body' color={colors.text.main} style={{
                whiteSpace: 'nowrap'
              }}>
                {deal?.name}
              </Typography>
            }
          />
        );
      })}
      {restDealsNumber ? (
        <TooltipComponent
          open={!!restDealsNumber && restDealsTooltipOpen}
          onOpen={handleRestDealsTooltipOpen}
          onClose={handleRestDealsTooltipClose}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              {restDeals?.map((item) => {
                return (
                  <Typography variant='body' color={colors.text.main} key={item.id}>
                    {item.name}
                  </Typography>
                );
              })}
            </Box>
          }
        >
          <Chip
            style={{
              backgroundColor: colors.surfaceStatus.noAction,
              minWidth: '66px',
              height: '28px',
            }}
            onClick={handleRestDealsTooltipOpen}
            label={
              <Typography variant='body' color={colors.text.main}>
                + {restDealsNumber} Deal
              </Typography>
            }
          />
        </TooltipComponent>
      ) : null}
    </Box>
  );
}

export default DealCell;
